/**
 * Audience based universal insider marketing page how to use carousel image urls
 * Product Area: INSIDER
 */
export const MARKETING_PAGE_HOW_TO_USE_INSIDER_CAROUSEL_IMAGE_URLS = 'MARKETING_PAGE_HOW_TO_USE_INSIDER_CAROUSEL_IMAGE_URLS';
